"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.telemetryBatchSchema = exports.telemetrySchema = exports.telemetryLocationSchema = void 0;
const zod_1 = require("zod");
exports.telemetryLocationSchema = zod_1.z
    .object({
    lat: zod_1.z.number().optional(),
    lon: zod_1.z.number().optional(),
    alt: zod_1.z.number().optional(),
    spdKph: zod_1.z.number().optional(),
    hdg: zod_1.z.number().optional(),
    fix: zod_1.z.enum(["none", "2d", "3d"]).optional(),
    sats: zod_1.z.number().int().optional(),
})
    .strict();
exports.telemetrySchema = zod_1.z
    .object({
    deviceId: zod_1.z.string(),
    ts: zod_1.z.string(),
    loc: exports.telemetryLocationSchema.optional(),
    veh: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    evt: zod_1.z.array(zod_1.z.string()).optional(),
    net: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    meta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    status: zod_1.z.string().optional(),
})
    .strict();
exports.telemetryBatchSchema = zod_1.z.array(exports.telemetrySchema);
